import { ES_LOCALE, MX_LOCALE, EN_LOCALE, PT_LOCALE } from '@/constants/locales'
import { i18nLocale, mergeLocaleMessage } from '@/plugins/i18n'
import { saveLangPrefCookie } from '@/helpers/cookies.helpers'
import { country } from '@/helpers/global.helpers'

let loadedTranslations = []

export function getNormalizedLocale() {
	return i18nLocale === MX_LOCALE ? ES_LOCALE : i18nLocale
}

export function normalize(translation) {
	if (!translation) { return null }
	return translation[getNormalizedLocale()] ? translation[getNormalizedLocale()] : translation['es']
}

export function normalizeProp(prop) {
	return `${prop}.${getNormalizedLocale()}`
}

export function changeLang(lang) {
	saveLangPrefCookie(`${country}/${lang}`)
	window.location.reload()
}

export function getCulture() {
	return i18nLocale === MX_LOCALE ? 'es-MX' : (i18nLocale === EN_LOCALE ? 'en-US' : (i18nLocale === PT_LOCALE ? 'pt-PT' : 'es-ES'))
}

export async function loadCommonTranslations(lang) {
	if ((lang === 'pt' || lang === 'mx') && !loadedTranslations.includes(`@/lang/es/common.json`)) {
		await import(`@/lang/es/common.json`).then(msgs => mergeLocaleMessage(lang, msgs.default || msgs))
		loadedTranslations.push(`@/lang/es/common.json`)
	}
	if (!loadedTranslations.includes(`@/lang/${lang}/common.json`)) {
		await import(`@/lang/${lang}/global-variables.json`).then(msgs => mergeLocaleMessage(lang, msgs.default || msgs))
		loadedTranslations.push(`@/lang/${lang}/global-variables.json`)
		await import(`@/lang/${lang}/common.json`).then(msgs => mergeLocaleMessage(lang, msgs.default || msgs))
		loadedTranslations.push(`@/lang/${lang}/common.json`)
	}
	return loadedTranslations
}

export async function loadTranslations(lang, files) {
	if (!lang) {
		lang = 'es'
	}
	loadedTranslations = await loadCommonTranslations(lang)
	if (files && files.length > 0) {
		for (let file of files) {
			if (file) {
				file = file.split('.json')[0]
				if (lang === MX_LOCALE && !loadedTranslations.includes(`@/lang/es/${file}.json`)) {
					await import(`@/lang/es/${file}.json`).then(msgs => mergeLocaleMessage(lang, msgs.default || msgs))
					loadedTranslations.push(`@/lang/es/${file}.json`)
				}
				// Check if translation is already loaded
				if (loadedTranslations.filter((item) => new RegExp(`@\/lang\/${lang}\/${file}\.json`).test(item)).length == 0) {
					try {
						await import(`@/lang/${lang}/${file}.json`).then(msgs => {
							if (msgs) {
								mergeLocaleMessage(lang, msgs.default || msgs)
								loadedTranslations.push(`@/lang/${lang}/${file}.json`)
							}
						})
					} catch (e) {}
				}
			}
		}
	}
}

export default {
	getNormalizedLocale,
	normalize,
	normalizeProp,
	changeLang,
	getCulture,
	loadCommonTranslations,
	loadTranslations
}


// WEBPACK FOOTER //
// ./src/helpers/i18n.helpers.js